import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t border-white/10 bg-party-ink pb-16" data-id="element-76" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-77" data-mp="32nul2myzi10u">
        <p className="text-[0.68rem] leading-snug text-white/60" data-id="element-78" data-mp="32pp4txyirn3c">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[0.64rem] leading-snug text-white/60" data-id="element-79" data-mp="3uf0nja26gata">
          {PRODUCT_NAME}™ es un producto educativo. No sustituye formación
          profesional, práctica supervisada, instrucciones de fabricantes,
          normas de seguridad, reglamentos del lugar, permisos ni el criterio de
          profesionales especializados cuando corresponda. Todo montaje debe
          realizarse utilizando estructuras estables, herramientas adecuadas y
          respetando las condiciones de seguridad del espacio.
        </p>
        <p className="mt-1 text-[0.68rem] text-white/80" data-id="element-80" data-mp="2eyjolhoo2ssi">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-party-gold transition-colors duration-150 ease-out hover:text-white" data-id="element-81" data-mp="3l90lhpgqmmw3">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-[0.68rem] text-white/80" data-id="element-82" data-mp="3v8hq03k96uqh">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-party-pastel" data-id="element-83" data-mp="828q8fh2gldw">
            Términos y Condiciones
          </a>
          <span className="text-white/40" data-id="element-84" data-mp="ht3a5d6ub8w6">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-party-pastel" data-id="element-85" data-mp="huwicwx3q16a">
            Política de Privacidad
          </a>
          <span className="text-white/40" data-id="element-86" data-mp="qtrns6sbn78j">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-party-pastel" data-id="element-87" data-mp="msg5ynfovqaw">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}